import useTranslation from 'hooks/useTranslation'
import Popup from './Popup'
import React from 'react'

const IdentificationDataPopup: React.FC = () => {
  const { t } = useTranslation('form.identificationData')
  return (
    <Popup>
      <div className='popup__title'>
        <i className='icon icon--logo' />
        <div>{t('title')}</div>
        <div>{t('desc')}</div>
      </div>
    </Popup>
  )
}

export default IdentificationDataPopup